<template>
  <b-modal
    :id="_id"
    hide-footer
    centered>

    <!--  Header  -->
    <template #modal-header="{ close }">
      <div class="w-100 d-flex justify-content-end">
        <span size="sm" class="cursor-pointer float-right" @click="close()">
          <b-icon-x-circle></b-icon-x-circle>
        </span>
      </div>
    </template>

    <!--  Body  -->
    <div class="mb-3">
      <p>{{ message }}</p>
    </div>

    <!--  Footer  -->
    <div class="d-flex justify-content-end">
      <b-button size="sm" class="bg-danger mx-1" @click="handleCancel">
        Back
      </b-button>
      <b-button size="sm" class="spnod-admin__form--button mx-1" @click="handleSuccess">
        OK
      </b-button>
    </div>

  </b-modal>
</template>

<script>
export default {
  name: 'Modal',
  props: ['_id', 'message'],
  methods: {
    handleCancel() {
      this.$bvModal.hide(this._id)
    },
    handleSuccess() {
      this.$bvModal.hide(this._id)
      this.$emit('success')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/components/Notifications/Modal.vue?578adff5